import { useId } from 'react';
import styles from './Card.module.css';

/** A dashboard module: article + header (title, count, sub, right slot) + body + optional foot. */
const Card = ({ id, module, title, hideTitle, count, sub, right, foot, busy, flush, className = '', children }) => {
    const reactId = useId();
    const headingId = `${id || reactId}-h`;
    return (
        <article
            className={`${styles.card} ${className}`}
            aria-labelledby={headingId}
            data-module={module}
        >
            <header className={styles.head}>
                <h2 id={headingId} className={`${styles.title} ${hideTitle ? styles.srOnly : ''}`}>
                    {title}
                </h2>
                {count !== undefined && count !== null && (
                    <span className={`${styles.count} num ${styles.num}`}>{count}</span>
                )}
                {sub && <span className={styles.sub}>{sub}</span>}
                {right && <div className={styles.right}>{right}</div>}
            </header>
            <div className={`${styles.body} ${flush ? styles.flush : ''}`} aria-busy={busy ? 'true' : undefined}>
                {children}
            </div>
            {foot && <footer className={styles.foot}>{foot}</footer>}
        </article>
    );
};

export default Card;
